// ============================================================================
// ecgRoles.ts — SSoT доступа к приложению «ЭКГ».
// Роли берутся по ИМЕНИ (JWT roles = roles.name): «Врач» — роль ядра
// «ГидраМедик» (medic core), «Студент»/«Преподаватель» — роли модуля ЭКГ.
// Дублей ролей нет: модуль использует роль ядра, а не создаёт свою.
// ============================================================================

import type { SecurityAccess } from '@/lib/securityRoles';

/** «Врач» — роль ядра «ГидраМедик» (medic core). */
export const ECG_DOCTOR_ROLE = 'Врач';
/** «Студент» — роль модуля ЭКГ. */
export const ECG_STUDENT_ROLE = 'Студент';
/** «Преподаватель» — роль модуля ЭКГ. */
export const ECG_TEACHER_ROLE = 'Преподаватель';


/** canUseEcg — доступ к приложению «ЭКГ» по ролям (без скрытых admin-дефолтов). */
export function canUseEcg(access: SecurityAccess): boolean {
  return access.roles.includes(ECG_DOCTOR_ROLE)
    || access.roles.includes(ECG_STUDENT_ROLE)
    || access.roles.includes(ECG_TEACHER_ROLE);
}
